import React, { useEffect, useRef, useState } from 'react'
import $ from "jquery";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import jszip from "jszip";
import { Link } from 'react-router-dom';
pdfMake.vfs = pdfFonts.vfs;
const RefereeManagement = () => {
    const [showRefereeModal, setShowRefereeModal] = useState(false);
    const [showChildModal, setShowChildModal] = useState(false);
    const [showHireModal, setShowHireModal] = useState(false);

    const table1 = useRef(null);
    const table2 = useRef(null);

    useEffect(() => {
        window.JSZip = jszip;

        let refereesTable, childRefereesTable;

        if (table1.current) {
            refereesTable = $(table1.current).DataTable({
                pageLength: 5,
                lengthChange: false,
                ordering: true,
                destroy: true,
                dom:
                    "<'row mb-3'<'col-sm-12 col-md-12'f>>" +
                    "<'row'<'col-sm-12'tr>>" +
                    "<'row mt-3'<'col-sm-12 col-md-12'i><'col-sm-12 col-md-12'B p>>",
                buttons: [
                    { extend: "copy", text: "Copy" },
                    { extend: "excel", text: "Excel" },
                    { extend: "pdf", text: "PDF" },
                    { extend: "print", text: "Print" },
                ],
            });
        }

        if (table2.current) {
            childRefereesTable = $(table2.current).DataTable({
                pageLength: 5,
                lengthChange: false,
                ordering: true,
                destroy: true,
                dom:
                    "<'row mb-3'<'col-sm-12 col-md-12'f>>" +
                    "<'row'<'col-sm-12'tr>>" +
                    "<'row mt-3'<'col-sm-12 col-md-12'i><'col-sm-12 col-md-12'B p>>",
                buttons: [
                    { extend: "copy", text: "Copy" },
                    { extend: "excel", text: "Excel" },
                    { extend: "pdf", text: "PDF" },
                    { extend: "print", text: "Print" },
                ],
            });
        }

        return () => {
            if (refereesTable) refereesTable.destroy();
            if (childRefereesTable) childRefereesTable.destroy();
        };
    }, []);
    return (
        <>
            <div className="page-wrapper referees-page">
                <div className="page-content p-4">
                    <div className="page-breadcrumb d-flex align-items-center mb-3">
                        <div className="breadcrumb-title pe-3">Referee Management</div>
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item"><Link to="/"><i className="bx bx-home-alt" /></Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Referees</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <hr />
                    <div className="card">
                        <div className="card-body">
                            <ul className="nav nav-tabs nav-primary" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <Link className="nav-link active" data-bs-toggle="tab" to="#referees-tab" role="tab">
                                        <div className="d-flex align-items-center">
                                            <div className="tab-icon"><i className="bx bx-user font-18 me-2" /></div>
                                            <div className="tab-title">Referees</div>
                                        </div>
                                    </Link>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <Link className="nav-link" data-bs-toggle="tab" to="#child-referees-tab" role="tab">
                                        <div className="d-flex align-items-center">
                                            <div className="tab-icon"><i className="bx bx-face font-18 me-2" /></div>
                                            <div className="tab-title">Child Referees</div>
                                        </div>
                                    </Link>
                                </li>
                            </ul>
                            {/* Tab Content */}
                            <div className="tab-content py-3">
                                {/* REFEREES TAB */}
                                <div className="tab-pane fade show active" id="referees-tab">
                                    <div className="entries-wrapper mb-3 home-entress">
                                        <label className="entries-label">
                                            <span>Showing</span>
                                            <select className="entries-select">
                                                <option value={10} selected>10</option>
                                                <option value={25}>25</option>
                                                <option value={50}>50</option>
                                                <option value={100}>100</option>
                                            </select>
                                            <span>Entries</span>
                                        </label>
                                    </div>
                                    {/* Sub Tabs for Referees */}
                                    <div className="sub-tabs">
                                        <button className="sub-tab active" data-status="all">All</button>
                                        <button className="sub-tab" data-status="applications">Applications</button>
                                        <button className="sub-tab" data-status="hired">Hired</button>
                                        <button className="sub-tab" data-status="invitation">Invitation Sent</button>
                                        <button className="sub-tab" data-status="declined">Declined</button>
                                    </div>
                                    {/* Referees Table */}
                                    <div className="table-responsive">
                                        <table id="refereesTable" ref={table1} className="table table-striped table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: '5%' }}>Photo</th>
                                                    <th style={{ width: '12%' }}>Name</th>
                                                    <th style={{ width: '15%' }}>Email</th>
                                                    <th style={{ width: '12%' }}>Experience Level</th>
                                                    <th style={{ width: '12%' }}>Seasons Available</th>
                                                    <th style={{ width: '12%' }}>Age Groups</th>
                                                    <th style={{ width: '10%' }}>Status</th>
                                                    <th style={{ width: '8%' }}>Rating</th>
                                                    <th style={{ width: '14%' }}>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr data-status="all hired">
                                                    <td><img src="images/avatars/avatar-1.png" className="ref-profile-img" alt="user" /></td>
                                                    <td>John Doe</td>
                                                    <td>john.doe@example.com</td>
                                                    <td><span className="badge bg-light-primary text-primary">Senior</span></td>
                                                    <td>2026-2026, 2026-2026</td>
                                                    <td><span className="badge bg-light-success">U14, Adult</span></td>
                                                    <td><span className="badge ">Hired</span></td>
                                                    <td><span className="rating-stars">★★★★★ (4.8)</span></td>
                                                    <td>
                                                        <div className="action-buttons">
                                                            <Link to="/referee-detail" className="view-referee">
                                                                <i className="bx bx-show" data-bs-toggle="tooltip" data-bs-placement="top" title="View Profile" />
                                                            </Link>
                                                            <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#hireModal">
                                                                <i className="bx bx-mail-send" data-bs-toggle="tooltip" data-bs-placement="top" title="Send Hire Invitation" />
                                                            </Link>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr data-status="all applications">
                                                    <td><img src="images/avatars/avatar-2.png" className="ref-profile-img" alt="user" /></td>
                                                    <td>Jane Smith</td>
                                                    <td>jane.smith@example.com</td>
                                                    <td><span className="badge bg-light-info text-info">Intermediate</span></td>
                                                    <td>2026-2026, 2026-2027</td>
                                                    <td><span className="badge bg-light-success">U10, U12, U14</span></td>
                                                    <td><span className="badge-status badge bg-warning">Application</span></td>
                                                    <td><span className="rating-stars">★★★★☆ (4.2)</span></td>
                                                    <td>
                                                        <div className="action-buttons">
                                                            <Link to="/referee-detail" className="view-referee">
                                                                <i className="bx bx-show" data-bs-toggle="tooltip" data-bs-placement="top" title="View Profile" />
                                                            </Link>
                                                            <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#hireModal">
                                                                <i className="bx bx-mail-send" data-bs-toggle="tooltip" data-bs-placement="top" title="Send Hire Invitation" />
                                                            </Link>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr data-status="all invitation hired">
                                                    <td><img src="images/avatars/avatar-3.png" className="ref-profile-img" alt="user" /></td>
                                                    <td>Robert Johnson</td>
                                                    <td>robert.j@example.com</td>
                                                    <td><span className="badge bg-light-primary text-primary">Senior</span></td>
                                                    <td>2026-2026, 2026-2026, 2026-2027</td>
                                                    <td><span className="badge bg-light-success">Adult</span></td>
                                                    <td><span className="badge ">Hired</span></td>
                                                    <td><span className="rating-stars">★★★★★ (4.9)</span></td>
                                                    <td>
                                                        <div className="action-buttons">
                                                            <Link to="/referee-detail" className="view-referee">
                                                                <i className="bx bx-show" data-bs-toggle="tooltip" data-bs-placement="top" title="View Profile" />
                                                            </Link>
                                                            <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#hireModal">
                                                                <i className="bx bx-mail-send" data-bs-toggle="tooltip" data-bs-placement="top" title="Send Hire Invitation" />
                                                            </Link>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr data-status="all declined">
                                                    <td><img src="images/avatars/avatar-4.png" className="ref-profile-img" alt="user" /></td>
                                                    <td>Sarah Williams</td>
                                                    <td>sarah.w@example.com</td>
                                                    <td><span className="badge bg-light-info text-info">Intermediate</span></td>
                                                    <td>2026-2026</td>
                                                    <td><span className="badge bg-light-success">U8, U10, U12</span></td>
                                                    <td><span className="badge-status badge bg-danger">Declined</span></td>
                                                    <td><span className="rating-stars">★★★☆☆ (3.5)</span></td>
                                                    <td>
                                                        <div className="action-buttons">
                                                            <Link to="/referee-detail" className="view-referee">
                                                                <i className="bx bx-show" data-bs-toggle="tooltip" data-bs-placement="top" title="View Profile" />
                                                            </Link>
                                                            <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#hireModal">
                                                                <i className="bx bx-mail-send" data-bs-toggle="tooltip" data-bs-placement="top" title="Send Hire Invitation" />
                                                            </Link>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr data-status="all hired">
                                                    <td><img src="images/avatars/avatar-5.png" className="ref-profile-img" alt="user" /></td>
                                                    <td>Michael Brown</td>
                                                    <td>michael.b@example.com</td>
                                                    <td><span className="badge bg-light-primary text-primary">Senior</span></td>
                                                    <td>2026-2026, 2026-2026</td>
                                                    <td><span className="badge bg-light-success">U12, U14, Adult</span></td>
                                                    <td><span className="badge ">Hired</span></td>
                                                    <td><span className="rating-stars">★★★★★ (4.7)</span></td>
                                                    <td>
                                                        <div className="action-buttons">
                                                            <Link to="/referee-detail" className="view-referee">
                                                                <i className="bx bx-show" data-bs-toggle="tooltip" data-bs-placement="top" title="View Profile" />
                                                            </Link>
                                                            <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#hireModal">
                                                                <i className="bx bx-mail-send" data-bs-toggle="tooltip" data-bs-placement="top" title="Send Hire Invitation" />
                                                            </Link>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                {/* CHILD REFEREES TAB */}
                                <div className="tab-pane fade" id="child-referees-tab">
                                    <div className="entries-wrapper mb-3 home-entress">
                                        <label className="entries-label">
                                            <span>Showing</span>
                                            <select className="entries-select">
                                                <option value={10} selected>10</option>
                                                <option value={25}>25</option>
                                                <option value={50}>50</option>
                                                <option value={100}>100</option>
                                            </select>
                                            <span>Entries</span>
                                        </label>
                                    </div>
                                    {/* Sub Tabs for Child Referees */}
                                    <div className="sub-tabs">
                                        <button className="sub-tab active" data-status="all">All</button>
                                        <button className="sub-tab" data-status="applications">Applications</button>
                                        <button className="sub-tab" data-status="hired">Hired</button>
                                        <button className="sub-tab" data-status="invitation">Invitation Sent</button>
                                        <button className="sub-tab" data-status="declined">Declined</button>
                                    </div>
                                    {/* Child Referees Table */}
                                    <div className="table-responsive">
                                        <table id="childRefereesTable" ref={table2} className="table table-striped table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: '5%' }}>Photo</th>
                                                    <th style={{ width: '12%' }}>Name</th>
                                                    <th style={{ width: '15%' }}>Email</th>
                                                    <th style={{ width: '10%' }}>Age</th>
                                                    <th style={{ width: '12%' }}>Experience Level</th>
                                                    <th style={{ width: '10%' }}>Status</th>
                                                    <th style={{ width: '8%' }}>Rating</th>
                                                    <th style={{ width: '14%' }}>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr data-status="all hired">
                                                    <td><img src="images/avatars/avatar-6.png" className="ref-profile-img" alt="user" /></td>
                                                    <td>Alex Turner</td>
                                                    <td>alex.turner@example.com</td>
                                                    <td>16 years</td>
                                                    <td><span className="badge bg-light-info text-info">Junior</span></td>
                                                    <td><span className="badge ">Hired</span></td>
                                                    <td><span className="rating-stars">★★★★☆ (4.3)</span></td>
                                                    <td>
                                                        <div className="action-buttons">
                                                            <Link to="/child-referees" className="view-child-referee">
                                                                <i className="bx bx-show" data-bs-toggle="tooltip" data-bs-placement="top" title="View Profile" />
                                                            </Link>
                                                            <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#hireModal">
                                                                <i className="bx bx-mail-send" data-bs-toggle="tooltip" data-bs-placement="top" title="Send Hire Invitation" />
                                                            </Link>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr data-status="all applications">
                                                    <td><img src="images/avatars/avatar-7.png" className="ref-profile-img" alt="user" /></td>
                                                    <td>Emma Davis</td>
                                                    <td>emma.davis@example.com</td>
                                                    <td>15 years</td>
                                                    <td><span className="badge bg-light-info text-info">Junior</span></td>
                                                    <td><span className="badge-status badge bg-warning">Application</span></td>
                                                    <td><span className="rating-stars">★★★★☆ (4.1)</span></td>
                                                    <td>
                                                        <div className="action-buttons">
                                                            <Link to="/child-referees" className="view-child-referee">
                                                                <i className="bx bx-show" data-bs-toggle="tooltip" data-bs-placement="top" title="View Profile" />
                                                            </Link>
                                                            <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#hireModal">
                                                                <i className="bx bx-mail-send" data-bs-toggle="tooltip" data-bs-placement="top" title="Send Hire Invitation" />
                                                            </Link>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
            <div>
                <div className="modal fade" id="viewRefereeModal" tabIndex={-1}>
                    <div className="modal-dialog modal-lg modal-dialog-scrollable">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Referee Details</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" />
                            </div>
                            <div className="modal-body">
                                {/* Profile Header */}
                                <div className="profile-header">
                                    <img src="images/avatars/avatar-1.png" className="profile-img" alt="user" />
                                    <div className="profile-info flex-grow-1">
                                        <h5>John Doe</h5>
                                        <p><i className="bx bx-envelope" /> john.doe@example.com</p>
                                        <p><i className="bx bx-phone" /> +1 234 567 890</p>
                                        <p><i className="bx bx-cake" /> Age: 32 years</p>
                                        <p><i className="bx bx-world" /> United States</p>
                                    </div>
                                    <div>
                                        <span className="hiring-status-badge hiring-status-hired">Hired</span>
                                    </div>
                                </div>
                                {/* Personal Details */}
                                <div className="form-section">
                                    <h6><i className="bx bx-user-circle" /> Personal Details</h6>
                                    <div className="row-info">
                                        <div className="info-group">
                                            <span className="info-label">Full Name</span>
                                            <span className="info-value">John Doe</span>
                                        </div>
                                        <div className="info-group">
                                            <span className="info-label">Email</span>
                                            <span className="info-value">john.doe@example.com</span>
                                        </div>
                                        <div className="info-group">
                                            <span className="info-label">Phone Number</span>
                                            <span className="info-value">+1 234 567 890</span>
                                        </div>
                                        <div className="info-group">
                                            <span className="info-label">Age</span>
                                            <span className="info-value">32 years</span>
                                        </div>
                                        <div className="info-group">
                                            <span className="info-label">Country</span>
                                            <span className="info-value">United States</span>
                                        </div>
                                    </div>
                                </div>
                                {/* Professional Details */}
                                <div className="form-section">
                                    <h6><i className="bx bx-briefcase" /> Professional Details</h6>
                                    <div className="row-info">
                                        <div className="info-group">
                                            <span className="info-label">Experience Level</span>
                                            <span className="info-value">Senior (5+ years)</span>
                                        </div>
                                        <div className="info-group">
                                            <span className="info-label">License Number</span>
                                            <span className="info-value">REF-2026-00151</span>
                                        </div>
                                        <div className="info-group">
                                            <span className="info-label">Match Count</span>
                                            <span className="info-value">287 matches</span>
                                        </div>
                                    </div>
                                    <div>
                                        <span className="info-label">Certifications</span>
                                        <span className="info-value">FIFA Level 2, National Badge</span>
                                    </div>
                                </div>
                                {/* Available Seasons */}
                                <div className="form-section">
                                    <h6><i className="bx bx-calendar" /> Available Seasons</h6>
                                    <div className="info-value">2026-2026, 2026-2026</div>
                                </div>
                                {/* Bank Details */}
                                <div className="form-section">
                                    <h6><i className="bx bx-building" /> Bank Details</h6>
                                    <div className="row-info">
                                        <div className="info-group">
                                            <span className="info-label">Bank Name</span>
                                            <span className="info-value">First National Bank</span>
                                        </div>
                                        <div className="info-group">
                                            <span className="info-label">Account Title</span>
                                            <span className="info-value">John Michael Doe</span>
                                        </div>
                                        <div className="info-group">
                                            <span className="info-label">Account Number</span>
                                            <span className="info-value">****1234</span>
                                        </div>
                                    </div>
                                </div>
                                {/* Ratings & Reviews */}
                                <div className="form-section">
                                    <h6><i className="bx bx-star" /> Ratings &amp; Reviews</h6>
                                    <div className="ratings-section">
                                        <div className="rating-item">
                                            <span>Overall Rating</span>
                                            <strong>★★★★★ 4.8/5.0</strong>
                                        </div>
                                        <div className="rating-item">
                                            <span>Professionalism</span>
                                            <strong>★★★★★ (98%)</strong>
                                        </div>
                                        <div className="rating-item">
                                            <span>Punctuality</span>
                                            <strong>★★★★★ (100%)</strong>
                                        </div>
                                        <div className="rating-item">
                                            <span>Decision Making</span>
                                            <strong>★★★★☆ (95%)</strong>
                                        </div>
                                        <div className="rating-item">
                                            <span>Communication</span>
                                            <strong>★★★★★ (97%)</strong>
                                        </div>
                                    </div>
                                </div>
                                {/* Documents */}
                                <div className="form-section">
                                    <h6><i className="bx bx-file" /> Documents</h6>
                                    <ul className="document-list">
                                        <li>
                                            <span><i className="bx bx-file me-2" /> Referee License</span>
                                            <i className="bx bx-download" />
                                        </li>
                                        <li>
                                            <span><i className="bx bx-file me-2" /> Background Check Certificate</span>
                                            <i className="bx bx-download" />
                                        </li>
                                        <li>
                                            <span><i className="bx bx-file me-2" /> Resume / CV</span>
                                            <i className="bx bx-download" />
                                        </li>
                                    </ul>
                                </div>
                                {/* Scheduled Games (for hired referees) */}
                                <div className="form-section">
                                    <h6><i className="bx bx-game" /> Scheduled Games</h6>
                                    <div className="info-value">
                                        <span className="badge bg-primary">12 Scheduled Games</span>
                                        <span className="badge bg-success ms-2">45 Completed Games</span>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button type="button" className="btn btn-hire">Send Hire Invitation</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="viewChildRefereeModal" tabIndex={-1}>
                    <div className="modal-dialog modal-lg modal-dialog-scrollable">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Child Referee Details</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" />
                            </div>
                            <div className="modal-body">
                                {/* Profile Header */}
                                <div className="profile-header">
                                    <img src="images/avatars/avatar-6.png" className="profile-img" alt="user" />
                                    <div className="profile-info flex-grow-1">
                                        <h5>Alex Turner</h5>
                                        <p><i className="bx bx-envelope" /> alex.turner@example.com</p>
                                        <p><i className="bx bx-phone" /> +1 456 789 123</p>
                                        <p><i className="bx bx-cake" /> Age: 16 years</p>
                                        <p><i className="bx bx-world" /> United States</p>
                                    </div>
                                    <div>
                                        <span className="hiring-status-badge hiring-status-hired">Hired</span>
                                    </div>
                                </div>
                                {/* Personal Details */}
                                <div className="form-section">
                                    <h6><i className="bx bx-user-circle" /> Personal Details</h6>
                                    <div className="row-info">
                                        <div className="info-group">
                                            <span className="info-label">Full Name</span>
                                            <span className="info-value">Alex Turner</span>
                                        </div>
                                        <div className="info-group">
                                            <span className="info-label">Email</span>
                                            <span className="info-value">alex.turner@example.com</span>
                                        </div>
                                        <div className="info-group">
                                            <span className="info-label">Contact Number</span>
                                            <span className="info-value">+1 456 789 123</span>
                                        </div>
                                        <div className="info-group">
                                            <span className="info-label">Age</span>
                                            <span className="info-value">16 years</span>
                                        </div>
                                        <div className="info-group">
                                            <span className="info-label">Country</span>
                                            <span className="info-value">United States</span>
                                        </div>
                                    </div>
                                </div>
                                {/* Parent Details */}
                                <div className="form-section">
                                    <h6><i className="bx bx-user" /> Connected Parent Details</h6>
                                    <div className="row-info">
                                        <div className="info-group">
                                            <span className="info-label">Parent Name</span>
                                            <span className="info-value">Michael Turner</span>
                                        </div>
                                        <div className="info-group">
                                            <span className="info-label">Email</span>
                                            <span className="info-value">michael.turner@example.com</span>
                                        </div>
                                        <div className="info-group">
                                            <span className="info-label">Contact Number</span>
                                            <span className="info-value">+1 456 789 000</span>
                                        </div>
                                    </div>
                                </div>
                                {/* Professional Details */}
                                <div className="form-section">
                                    <h6><i className="bx bx-briefcase" /> Professional Details</h6>
                                    <div className="row-info">
                                        <div className="info-group">
                                            <span className="info-label">Experience Level</span>
                                            <span className="info-value">Junior (2+ years)</span>
                                        </div>
                                        <div className="info-group">
                                            <span className="info-label">License Number</span>
                                            <span className="info-value">REF-2026-00287</span>
                                        </div>
                                        <div className="info-group">
                                            <span className="info-label">Match Count</span>
                                            <span className="info-value">52 matches</span>
                                        </div>
                                    </div>
                                    <div>
                                        <span className="info-label">Certifications</span>
                                        <span className="info-value">Basic Referee Course, Youth Badge</span>
                                    </div>
                                </div>
                                {/* Bank Details */}
                                <div className="form-section">
                                    <h6><i className="bx bx-building" /> Bank Details (Parent Account)</h6>
                                    <div className="row-info">
                                        <div className="info-group">
                                            <span className="info-label">Bank Name</span>
                                            <span className="info-value">Community Bank</span>
                                        </div>
                                        <div className="info-group">
                                            <span className="info-label">Account Title</span>
                                            <span className="info-value">Michael Turner</span>
                                        </div>
                                        <div className="info-group">
                                            <span className="info-label">Account Number</span>
                                            <span className="info-value">****5678</span>
                                        </div>
                                    </div>
                                </div>
                                {/* Ratings & Reviews */}
                                <div className="form-section">
                                    <h6><i className="bx bx-star" /> Ratings &amp; Reviews</h6>
                                    <div className="ratings-section">
                                        <div className="rating-item">
                                            <span>Overall Rating</span>
                                            <strong>★★★★☆ 4.3/5.0</strong>
                                        </div>
                                        <div className="rating-item">
                                            <span>Professionalism</span>
                                            <strong>★★★★☆ (92%)</strong>
                                        </div>
                                        <div className="rating-item">
                                            <span>Punctuality</span>
                                            <strong>★★★★★ (100%)</strong>
                                        </div>
                                        <div className="rating-item">
                                            <span>Decision Making</span>
                                            <strong>★★★★☆ (90%)</strong>
                                        </div>
                                        <div className="rating-item">
                                            <span>Communication</span>
                                            <strong>★★★★☆ (93%)</strong>
                                        </div>
                                    </div>
                                </div>
                                {/* Documents */}
                                <div className="form-section">
                                    <h6><i className="bx bx-file" /> Documents</h6>
                                    <ul className="document-list">
                                        <li>
                                            <span><i className="bx bx-file me-2" /> Referee License</span>
                                            <i className="bx bx-download" />
                                        </li>
                                        <li>
                                            <span><i className="bx bx-file me-2" /> Background Check Certificate</span>
                                            <i className="bx bx-download" />
                                        </li>
                                        <li>
                                            <span><i className="bx bx-file me-2" /> Resume / CV</span>
                                            <i className="bx bx-download" />
                                        </li>
                                    </ul>
                                </div>
                                {/* Scheduled Games (for hired referees) */}
                                <div className="form-section">
                                    <h6><i className="bx bx-game" /> Scheduled Games</h6>
                                    <div className="info-value">
                                        <span className="badge bg-primary">8 Scheduled Games</span>
                                        <span className="badge bg-success ms-2">12 Completed Games</span>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button type="button" className="btn btn-hire">Send Hire Invitation</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="hireModal" tabIndex={-1}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Send Hire Invitation</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" />
                            </div>
                            <div className="modal-body">
                                <form>
                                    <div className="mb-3">
                                        <label className="form-label">Referee Name</label>
                                        <input type="text" className="form-control" defaultValue="John Doe" readOnly />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Email</label>
                                        <input type="email" className="form-control" defaultValue="john.doe@example.com" readOnly />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Message</label>
                                        <textarea className="form-control" rows={4} placeholder="Enter invitation message..." defaultValue={""} />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Contract Terms</label>
                                        <textarea className="form-control" rows={3} placeholder="Enter contract terms..." defaultValue={""} />
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-hire">Send Invitation</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>






        </>
    )
}

export default RefereeManagement